import Link from "../../components/Link";
import React from "react";
import compose from "recompose/compose";
import { get } from "lodash";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    color: grey[900],
  },
});

const SensorField = ({
  source,
  record,
  classes,
  basePath,
  resource,
  sortBy,
  ...props
}) => {
  const stopPropagation = (e) => e.stopPropagation();
  return (
    <Link
      className={classes.root}
      onClick={(e) => {
        const fullHash = window.location.hash;
        localStorage.setItem("sensor_origin", fullHash);
        e.stopPropagation();
      }}
      target={"_blank"}
      href={`#/sensor/${record.sensor.id}`}
      variant="body1"
      {...props}
    >
      {get(record, source)}
    </Link>
  );
};
export default compose(withStyles(styles))(SensorField);
